import { useEffect, useRef } from "react";
import { UpdateCanvasAndViewportDimensionsFunction } from "../extensions/viewportInitializerExtension";
import { useTemplateViewportSize } from "./useTemplateViewportSize";

export function useCanvasAndViewportDimensions() {
  const updateDimensionsFunctionRef = useRef<UpdateCanvasAndViewportDimensionsFunction>(() => {});
  const { viewportSize, viewportSettingsRef } = useTemplateViewportSize();

  useEffect(() => {
    updateDimensionsFunctionRef.current();
  }, [viewportSize]);

  const initCanvasAndViewportUpdateDimensionsFunction = (fn: UpdateCanvasAndViewportDimensionsFunction) => {
    updateDimensionsFunctionRef.current = fn;
  };

  return {
    initCanvasAndViewportUpdateDimensionsFunction,
    viewportSettingsRef,
  };
}
